import React from "react";
import { Trans } from "react-i18next";

import { Tag, Button, Callout, Alert } from "@blueprintjs/core";

import { authenticatedDeleteFetch } from "../../../../utils/AuthenticatedFetch";
import { mefDate, mefMontantStr } from "../../../../utils/mef";
import i18n from "../../../../i18n";

export function deviceLabel(devices_def, id) {
  if (devices_def) {
    const device_def = devices_def.filter((i) => i.id === id)[0];
    if (device_def !== undefined) return device_def.name;
  }
  return id;
}

function DeviceList(props) {
  return props.devices.map((device, index) => (
    <Tag key={index}>{deviceLabel(props.device_def, device)}</Tag>
  ));
}

function deviceTypeSpecial(device_def, props) {
  return (
    <div>
      {props.start_date && props.end_date && (
        <Callout intent="primary">
          <span>
            <Trans>from</Trans> {mefDate(props.start_date)}
          </span>{" "}
          <span>
            <Trans>to</Trans> {mefDate(props.end_date)}
          </span>
        </Callout>
      )}
      <ul>
        {props.closed && props.closed.length > 0 && (
          <li>
            <Trans>closed</Trans> :{" "}
            <DeviceList device_def={device_def} devices={props.closed} />
          </li>
        )}
        {props.full_open && props.full_open.length > 0 && (
          <li>
            <Trans>OBM</Trans> :{" "}
            <DeviceList device_def={device_def} devices={props.full_open} />
          </li>
        )}
        {props.free_payment && props.free_payment.length > 0 && (
          <li>
            <Trans>free payment</Trans> :{" "}
            <DeviceList device_def={device_def} devices={props.free_payment} />
          </li>
        )}
        {props.flat_fare_payment && props.flat_fare_payment.length > 0 && (
          <li>
            <Trans>flat fare payment</Trans> :{" "}
            <DeviceList
              device_def={device_def}
              devices={props.flat_fare_payment}
            />
          </li>
        )}
      </ul>
    </div>
  );
}

export default class Show extends React.Component {
  constructor(props) {
    super();
    this.state = { deleting: false };
  }
  render() {
    return (
      <Callout
        title={
          <span className="flexbox-center-large">
            {this.props.name}
            {localStorage.getItem("perm_tarif") === "true" &&
              !this.props.showOnly && (
                <Button
                  icon="cross"
                  minimal={true}
                  onClick={() => this.setState({ deleting: true })}
                />
              )}
          </span>
        }
        style={{ marginBottom: 10 }}
      >
        <div>
          <Trans>from</Trans> {mefDate(this.props.start_date)}
        </div>
        <div>
          <Trans>to</Trans> {mefDate(this.props.end_date)}
        </div>
        {this.props.flat_fare !== undefined ? (
          <div>
            <Trans>price:</Trans>
            <Trans>flat fare of</Trans>{" "}
            <Tag intent="primary">{mefMontantStr(this.props.flat_fare)}</Tag>
          </div>
        ) : (
          <div>
            <Trans>price:</Trans>
            <Trans>price computed from</Trans>{" "}
            <Tag intent="primary">
              <Trans>tarif code</Trans> n°{JSON.stringify(this.props.tariff)}
            </Tag>
          </div>
        )}
        <div>
          <Trans>delay after show:</Trans>
          <Tag intent="primary">
            {JSON.stringify(this.props.delay_after_show)} <Trans>minutes</Trans>
          </Tag>
        </div>

        <div className="flexbox-left">
          {this.props.entry_gate &&
            ((this.props.entry_gate.closed &&
              this.props.entry_gate.closed.length > 0) ||
              (this.props.entry_gate.full_open &&
                this.props.entry_gate.full_open.length > 0) ||
              (this.props.entry_gate.free_payment &&
                this.props.entry_gate.free_payment.length > 0) ||
              (this.props.entry_gate.flat_fare_payment &&
                this.props.entry_gate.flat_fare_payment.length > 0)) && (
              <Callout title={<Trans>E</Trans>}>
                {deviceTypeSpecial(
                  this.props.device_def,
                  this.props.entry_gate
                )}
              </Callout>
            )}

          {this.props.exit_gate &&
            ((this.props.exit_gate.closed &&
              this.props.exit_gate.closed.length > 0) ||
              (this.props.exit_gate.full_open &&
                this.props.exit_gate.full_open.length > 0) ||
              (this.props.exit_gate.free_payment &&
                this.props.exit_gate.free_payment.length > 0) ||
              (this.props.exit_gate.flat_fare_payment &&
                this.props.exit_gate.flat_fare_payment.length > 0)) && (
              <Callout title={<Trans>S</Trans>}>
                {deviceTypeSpecial(this.props.device_def, this.props.exit_gate)}
              </Callout>
            )}

          {this.props.automatic_pay_machine &&
            ((this.props.automatic_pay_machine.closed &&
              this.props.automatic_pay_machine.closed.length > 0) ||
              (this.props.automatic_pay_machine.flat_fare_payment &&
                this.props.automatic_pay_machine.flat_fare_payment.length >
                  0)) && (
              <Callout title={<Trans>C</Trans>}>
                {deviceTypeSpecial(
                  this.props.device_def,
                  this.props.automatic_pay_machine
                )}
              </Callout>
            )}

          {this.props.pedestrian_reader &&
            ((this.props.pedestrian_reader.closed &&
              this.props.pedestrian_reader.closed.length > 0) ||
              (this.props.pedestrian_reader.full_open &&
                this.props.pedestrian_reader.full_open.length > 0)) && (
              <Callout title={<Trans>LP</Trans>}>
                {deviceTypeSpecial(
                  this.props.device_def,
                  this.props.pedestrian_reader
                )}
              </Callout>
            )}
        </div>

        <Alert
          confirmButtonText={i18n.t("delete")}
          cancelButtonText={i18n.t("cancel")}
          isOpen={this.state.deleting}
          onClose={() => this.setState({ deleting: false })}
          onConfirm={() =>
            authenticatedDeleteFetch(
              "/tarif/show?srv=" + this.props.srv,
              { id: this.props.reference },
              () =>
                this.setState({ deleting: false }, () => this.props.onChange())
            )
          }
          canEscapeKeyCancel={true}
          canOutsideClickCancel={true}
          intent="danger"
          icon="trash"
        >
          <p>
            <Trans>are you sure you want to delete this show</Trans>
          </p>
        </Alert>
      </Callout>
    );
  }
}

/*  */
